function formatThousands(num) {
  var values = num.toString().split(".");
  return values[0].replace(/.(?=(?:.{3})+$)/g, "$&,") + (values.length == 2 ? "." + values[1] : "");
}

const emptyCartElement = `
<div class="quick_cart__empty ff-body fs-body-base visible" data-empty="">
    Your cart is currently empty.
</div>
`;

function getCartFooter(cart) {
  let formattedPrice = (cart.total_price / 100).toFixed(2);
  let priceString = formatThousands(formattedPrice);
  return `
      <div class="quick-cart__footer ff-body fs-body-base ta-c visible" data-footer="">
          <div class="quick-cart__discounts c-subdued" data-discounts=""></div>
          <ul class="quick-cart__summary">
            <li>
              <strong>
                <span>Subtotal</span>
              </strong>
              <span>$${priceString}</span>
            </li>
            <li>
              <strong>
                <span>Shipping/Taxes</span>
              </strong>
              <span>Will be calculated at checkout</span>
            </li>
          </ul>
          <form action="/cart" method="post" data-form novalidate>
          <input type="submit" name="checkout" class="btn btn--primary btn--full" value="Check Out">
          </form> 
          <a id="close-quick-cart-continue-shopping" class="quick-cart__continue-shopping">Continue Shopping</a>
      </div>
  `;
}

function removeItemFromCart(el) {
  const variantId = $(el).attr("data-id");
  const emptyCartElement = `
  <div class="quick_cart__empty ff-body fs-body-base visible" data-empty="">
      Your cart is currently empty.
  </div>
  `;

  const cartItem = $(el).parents(".quick-cart__item[data-id='" + variantId + "']");
  if (cartItem) {
    jQuery.post("/cart/update.js", `updates[${variantId}]=0`, function (res) {
      const cartData = JSON.parse(res);
      cartItem.remove();
      if (cartData.item_count == 0) {
        $(".quick-cart__footer").remove();
        $(emptyCartElement).insertAfter(".quick-cart__header");
        $(".header__cart-count").removeClass("visible");
        localStorage.setItem("claimed-free-gift", "false");
      } else {
        $("#js-cart-count").text(cartData.item_count);
      }

      if (cartData.total_price < 50000) {
        localStorage.setItem("claimed-free-gift", "false");
      }

      updateGiftNotification(cartData);
    });
  }
}

function getCartItem(item) {
  return `
      <div class="quick-cart__item ff-body fs-body-base" data-id="${item.id}">
          <div class="quick-cart__item-left">
              <a href="${item.url}?variant=${item.variant_id}">
                  <div class="quick-cart__image"><img class="image__img lazyloaded" data-src="${item.image}" src="${
    item.image
  }"></div>
              </a>
          </div>
          <div class="quick-cart__item-right">
              <h4><a href="${item.url}?variant=${item.variant_id}">${item.title}</a></h4>
              <p class="quick-cart__key-feature" style='${
                item.properties && item.properties.key_feature == undefined ? "display:none;" : ""
              }'>${item.properties ? item.properties.key_feature : ""}</p>
              <p class="quick-cart__key-fitment" style='${
                item.properties && item.properties.fitment == undefined ? "display:none;" : ""
              }'>${item.properties ? item.properties.fitment : ""}</p>
              <p class="quick-cart__sku">SKU ${item.sku}</p>
              <div class="quick-cart__item-price">
                  $${item.price / 100}
                  <span class="c-subdued quick-cart__item-quantity">x ${item.quantity}</span>
              </div>
              ${item.variant_title ? `<div>Option: ${item.variant_title}</div>` : ``}
          </div>
          <button onclick="removeItemFromCart(this)" class="remove-item-btn" data-id="${item.id}"> 
              <svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z" fill="currentColor"/>
              </svg>
          </button>
      </div>
`;
}

function quickAddToCart(e, vid) {
  renderCartUpsell();
  let selected = [];

  var singleVariantId = vid ? vid : $(e).data("variant-id");
  let feature = $(e).data("key-feature");
  let fitment = $(e).data("key-fitment");
  var isBundleProduct = $(e).is('[data-is-bundle-product]');
  var bundleConfigured = $(e).is('[data-bundle-is-configured]');

  if (isBundleProduct) {
    
    var selectedVariants = bundleConfigured ? $('[data-bundle-item-variant].is-selected') : $('[data-bundle-item-variant-default]')

    selected = $(selectedVariants).map(function() {
      let bundleVariantId = $(this).data('bundle-item-variant-id');
      return selected = [
        {
          id: bundleVariantId,
          quantity: 1,
          properties: {
            key_feature: feature,
            fitment: fitment
          }
        }
      ]
    }).toArray();

  } else {
    selected = [
      {
        id: singleVariantId,
        quantity: 1,
        properties: {
          key_feature: feature,
          fitment: fitment
        }
      }
    ];
  }

  if (
    localStorage.getItem(`${LOCAL_STORAGE_VERSION}year-option`) &&
    localStorage.getItem(`${LOCAL_STORAGE_VERSION}make-type`) &&
    localStorage.getItem(`${LOCAL_STORAGE_VERSION}model-type`) &&
    localStorage.getItem(`${LOCAL_STORAGE_VERSION}engine-type`)
  ) {
    let selectedVehicle =
      localStorage.getItem(`${LOCAL_STORAGE_VERSION}year-option`) +
      ", " +
      localStorage.getItem(`${LOCAL_STORAGE_VERSION}make-type`) +
      ", " +
      localStorage.getItem(`${LOCAL_STORAGE_VERSION}model-type`) +
      ", " +
      localStorage.getItem(`${LOCAL_STORAGE_VERSION}engine-type`);

    selected[0].properties = {
      ...selected[0].properties,
      "Selected for": selectedVehicle,
    };
  }

  let formData = {
    items: selected,
    sections: "header, quick-cart",
  };

  if (selected.length > 0) {
    if (!$(e).hasClass("loading")) {
      $(e).addClass("loading");
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Fetch not successful");
        return res.json();
      })
      .then((data) => {
        const element = $.parseHTML(data.sections.header);
        $("#shopify-section-header").replaceWith(element);

        $(e).removeClass("loading");
//      initCartOpen(data.items[data.items.length - 1].id);

        jQuery.get("/cart.js", function (res) {
          let data = JSON.parse(res);
          for (let i = 0; i < data.items.length; i++) {
            let element = getCartItem(data.items[i]);
            $(".quick-cart__items").append(element);
          }
          $(getCartFooter(data)).insertAfter(".quick-cart__items");
          renderUpsellSection();

          $(".quick-cart").addClass("active visible");

          $(document)
            .find("a[data-js-cart-icon]")
            .bind("click", function () {
              $(".quick-cart").toggleClass("active visible");
            });

          $("#close-quick-cart").click(() => {
            $(".quick-cart").removeClass("active visible");
            $(".quick-cart__overlay").trigger("click");
          });

          $("#close-quick-cart-continue-shopping").click(() => {
            $(".quick-cart").removeClass("active visible");
            $(".quick-cart__overlay").trigger("click");
          });

          $("#gift-button").click(function (event) {
            if (!$(event.target).closest("#choose-gift").length) {
              $(".gift-notification").css("display", "flex");
              $(".gift-notification__overlay").show();
            }
          });

          updateGiftNotification(data);

          if (giftClaimed() === false && data.total_price >= getThreshold()) {
            $("#gift-modal").show();
          }
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

function initCartOpen() {
  jQuery.get("/cart.js", function (res) {
    let data = JSON.parse(res);
    $(".quick-cart__items").empty();
    if (data.items.length == 0) {
      $(emptyCartElement).insertAfter(".quick-cart__header");
    } else {
      $(getCartFooter(data)).insertAfter(".quick-cart__items");
      $("#close-quick-cart-continue-shopping").click(() => {
        $(".quick-cart").removeClass("active visible");
        $(".quick-cart__overlay").trigger("click");
      });
      for (let i = 0; i < data.items.length; i++) {
        let element = getCartItem(data.items[i]);
        $(".quick-cart__items").append(element);
      }
    }
  });
}

function renderCartUpsell() {
  const upsellComponent = $(".quick-cart__upsell");
  const upsellProducts = $(".quick-cart__upsell-products");
}

// helper fnc for vehicle selection products with no variant id
function quickAddToCartProduct(e) {
  var productHandle = $(e).data("product-handle");
  var variantId;

  if (productHandle) {
    $(e).addClass("loading");
    $.getJSON(`/products/${productHandle}`, function (data) {
      variantId = data.product.variants[0].id;
      quickAddToCart(e, variantId);
    });
  }
}

$(document).ready(() => {
  initCartOpen();
  $("#close-quick-cart").click(() => {
    $(".quick-cart").removeClass("active visible");
    $(".quick-cart__overlay").trigger("click");
  });
  $("#close-quick-cart-continue-shopping").click(() => {
    $(".quick-cart").removeClass("active visible");
    $(".quick-cart__overlay").trigger("click");
  });
});
